import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const name = "worklocation";
const initialState = {
  worklocation: 18,
  loading: false,
  error: null,
};

export const setWorkLocation = createAsyncThunk(
  "worklocation",
  async (limit) => {
    return limit;
  }
);

const worklocationSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(setWorkLocation.fulfilled, (state, action) => {
      state.worklocation = action.payload;
      state.loading = false;
      state.error = null;
    });
  },
});

export default worklocationSlice.reducer;
